(function () {
  'use strict';

  if (window.__ERECTUS_PDP_CART_FIX__) return;
  window.__ERECTUS_PDP_CART_FIX__ = true;

  var busy = false;

  function normalizeId(value) {
    var match = String(value || '').match(/\d+/g);
    return match ? match[match.length - 1] : '';
  }

  function getMainButton(target) {
    if (!target || !target.closest) return null;
    return target.closest('.main-content-detail .details-info .js_add_to_cart_button[data-js-product-button-add-to-cart]');
  }

  function getVariantId(form, button) {
    var select = form.querySelector('select[name="id"]');
    var id = select ? normalizeId(select.value) : '';
    if (id) return id;

    var input = form.querySelector('input[name="id"]');
    id = input ? normalizeId(input.value) : '';
    if (id) return id;

    var variantInput = form.querySelector('input[name="variant_id"]');
    id = variantInput ? normalizeId(variantInput.value) : '';
    if (id) return id;

    return normalizeId(button.getAttribute('data-pid') || button.dataset.pid || '');
  }

  function getQuantity(form) {
    var input = form.querySelector('[name="quantity"]');
    var qty = parseInt(input ? input.value : '1', 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getSellingPlan(form, details) {
    var seal = details.querySelector('.sealsubs-target-element') || document.querySelector('.sealsubs-target-element.sls-homepage-automatic.sealsubs-full');
    if (!seal) return '';

    var oneTime = seal.querySelector('input.sls-option[data-type="one_time"], input.sls-option[data-type="one-time"]');
    var recurring = seal.querySelector('input.sls-option[data-type="subscription"]');

    if (oneTime && oneTime.checked) return '';

    if (recurring && recurring.checked) {
      var formPlan = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
      if (formPlan && normalizeId(formPlan.value)) return normalizeId(formPlan.value);

      var interval = seal.querySelector('select.sls-select[name="subs_interval"]');
      if (interval && normalizeId(interval.value)) return normalizeId(interval.value);

      var hidden = seal.querySelector('[data-sls-selling_plan][name="selling_plan"], input[name="selling_plan"], select[name="selling_plan"]');
      if (hidden && normalizeId(hidden.value)) return normalizeId(hidden.value);
    }

    if (!oneTime && !recurring) {
      var fallback = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]') || seal.querySelector('select.sls-select[name="subs_interval"], [data-sls-selling_plan][name="selling_plan"]');
      if (fallback && normalizeId(fallback.value)) return normalizeId(fallback.value);
    }

    return '';
  }

  function getMessage(details) {
    var message = details.querySelector('.erectus-pdp-cart-message');
    if (message) return message;

    message = document.createElement('div');
    message.className = 'erectus-pdp-cart-message';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.style.cssText = 'display:none;margin:8px 0 0;font-size:14px;line-height:1.35;';

    var meta = details.querySelector('.cms-product-meta');
    if (meta) meta.insertAdjacentElement('afterend', message);
    else details.appendChild(message);
    return message;
  }

  function showMessage(details, text, isError) {
    var message = getMessage(details);
    message.textContent = text;
    message.style.display = 'block';
    message.style.fontWeight = isError ? '600' : '500';
  }

  function setButtonState(button, text) {
    var label = button.querySelector('.text');
    if (label) label.textContent = text;
    button.classList.remove('ajax_loading');
    button.style.pointerEvents = 'auto';
    button.removeAttribute('aria-busy');
  }

  function updateCounts(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count === null) return;

    document.querySelectorAll('.js-cart-count, [data-js-cart-count], .jsccount').forEach(function (node) {
      node.textContent = count;
      if (node.hasAttribute('data-js-cart-count')) node.setAttribute('data-js-cart-count', count);
    });
  }

  function openCartDrawer() {
    var ids = ['#js_cart_popup', '#js_nt_cart_canvas'];
    for (var i = 0; i < ids.length; i++) {
      var target = document.querySelector(ids[i]);
      var trigger = document.querySelector('.push_side[data-id="' + ids[i] + '"]');
      if (target && trigger) {
        trigger.click();
        return true;
      }
    }
    return false;
  }

  async function addMainProduct(button) {
    if (busy) return;

    var details = button.closest('.details-info');
    var form = button.closest('form') || (details && details.querySelector('form[action*="/cart/add"]'));
    if (!details || !form) return;

    var variantId = getVariantId(form, button);
    if (!variantId) {
      showMessage(details, 'No pude identificar la variante. Recarga la página e inténtalo nuevamente.', true);
      return;
    }

    busy = true;
    var label = button.querySelector('.text');
    var originalText = label ? label.textContent : 'Agregar al carrito';
    button.classList.add('ajax_loading');
    button.style.pointerEvents = 'none';
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'AGREGANDO…';

    var data = new FormData(form);
    data.set('id', variantId);
    data.set('quantity', String(getQuantity(form)));
    data.delete('variant_id');

    var sellingPlan = getSellingPlan(form, details);
    if (sellingPlan) data.set('selling_plan', sellingPlan);
    else data.delete('selling_plan');

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data,
        credentials: 'same-origin'
      });
      var result = await response.json().catch(function () { return {}; });

      if (!response.ok) {
        var description = String(result.description || result.message || 'No se pudo agregar el producto.');
        if (response.status === 422 && /stock|available|dispon|inventory|cantidad|quantity/i.test(description)) {
          description = 'Solo queda 1 unidad disponible. Revisa si ya está en tu carrito.';
        }
        showMessage(details, description, true);
        setButtonState(button, originalText);
        return;
      }

      var cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .catch(function () { return null; });
      updateCounts(cart);

      showMessage(details, '✓ Agregado al carrito', false);
      setButtonState(button, '✓ AGREGADO');

      try {
        if (window.cmsheroShopify && typeof window.cmsheroShopify.onCartUpdate === 'function') {
          window.cmsheroShopify.onCartUpdate(1, 1, result.product_id || null);
        }
      } catch (_) {}

      window.setTimeout(function () {
        if (!openCartDrawer()) setButtonState(button, originalText);
      }, 350);

      window.setTimeout(function () {
        setButtonState(button, originalText);
      }, 1600);
    } catch (_) {
      showMessage(details, 'No se pudo conectar con el carrito. Inténtalo nuevamente.', true);
      setButtonState(button, originalText);
    } finally {
      busy = false;
    }
  }

  document.addEventListener('click', function (event) {
    var button = getMainButton(event.target);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    addMainProduct(button);
  }, true);
})();
